module.exports = __webpack_public_path__ + "static/img/p16.5d639fad.png";